import useSWR from 'swr';
import { PlayerStatsFragment } from '@amf/shared/types/graphql';
import { useMemo } from 'react';

const API_KEY = '/api/player/stats';
const getCacheKey = (player: string) => () => {
  const params = new URLSearchParams({ player });
  return `${API_KEY}?${params.toString()}`;
};

function usePlayerStats(player: string) {
  const { data, error } = useSWR<PlayerStatsFragment[]>(getCacheKey(player));
  const stats = useMemo(() => (data && Array.isArray(data) ? data : []), [data]);
  const summary = useMemo<PlayerStatsFragment>(() => {
    if (!stats || stats.length === 0) return null;
    return {
      id: 'summary',
      leagueName: null,
      season: null,
      teams: [],
      goals: stats.map(s => s.goals).reduce((p, c) => p + c),
      matches: stats.map(s => s.matches).reduce((p, c) => p + c),
      points: stats.map(s => s.points).reduce((p, c) => p + c),
      assists: stats.map(s => s.assists).reduce((p, c) => p + c),
      redCards: stats.map(s => s.redCards).reduce((p, c) => p + c),
      yellowCards: stats.map(s => s.yellowCards).reduce((p, c) => p + c),
      receivedGoals: stats.map(s => s.receivedGoals).reduce((p, c) => p + c),
    };
  }, [stats]);

  return {
    error,
    stats,
    summary,
    loading: !data && !error,
  };
}

export default usePlayerStats;
